export const CONSUMER_PAYMENTS_ALIAS = 'Payments'
export const CONSUMER_CART_ALIAS = 'Cart'
export const EVENT_NOTIFICATIONS_ALIAS = 'Event__Notifications'
export const IMPERSONATE_USER_ID_LS_ALIAS = 'impersonateUserId'
export const IMPERSONATE_USER_EMAIL_LS_ALIAS = 'impersonateUserEmail'
